<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2 py-md-0"
    >
      <!-- LEAD PROFILE PICTURE -->
      <div
        v-if="!isMobile()"
        class="position-absolute px-1 d-none d-md-block"
        :style="{
          marginLeft: showCustomerSuggestion ? '430px' : '200px',
          marginTop: '-26px'
        }"
      >
        <BButton
          size="sm"
          variant="link"
          class="text-dark"
          @click.prevent="showOrHideCustomerSuggestions"
        >
          {{ showCustomerSuggestion ? 'Hide' : 'Show' }} Customer Suggestions by Municipality
        </BButton>
      </div>
      <BCol
        v-if="showCustomerSuggestion || isMobile()"
        cols="12"
        md="2"
        style="margin-top: 24px;"
        order="2"
        order-md="1"
      >
        <CustomerSuggestions
          ref="customerSuggestions"
          :customer="customerProfile"
        />
      </BCol>

      <BCol
        cols="12"
        :md="showCustomerSuggestion ? 10 : 12"
        order="1"
        order-md="2"
      >
        <BRow class="gap-y-2">
          <BCol
            cols="12"
          >
            <CustomerProfilePictures
              ref="customerProfilePictures"
              :loading="state.busy"
              :customer="customerProfile"
            />
          </BCol>

          <!-- LEAD INFORMATIONS -->
          <BCol
            cols="12"
          >
            <BOverlay
              :show="state.busy"
              opacity="0.5"
            >
              <BCard
                class="border min-h-550px"
              >
                <BCardText>
                  <BTabs
                    v-model="currentTabIndex"
                    nav-class="scrollable-x-tabs no-scrollbar nav-customer-tabs gap-x-1"
                    pills
                  >
                    <template #tabs-start>
                      <div class="nav-item">
                        <div
                          class="d-flex align-items-center position-absolute"
                          style="padding: 2px 1px; height: 38px;"
                        >
                          <i
                            class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
                            style="font-size: 20px;"
                          />
                        </div>
                      </div>
                    </template>
                    <template #tabs-end>
                      <div class="nav-item">
                        <div
                          class="d-flex align-items-center position-absolute"
                          style="right: 20px; padding: 2px 1px; height: 38px;"
                        >
                          <i
                            class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
                            style="font-size: 20px;"
                          />
                        </div>
                      </div>
                    </template>
                    <BTab>
                      <template #title>
                        <i :class="iconState('fa-file-user', currentTabIndex === 0)" /> Info
                      </template>

                      <BContainer
                        class="h-100 p-0"
                        fluid
                      >
                        <CustomerInformations
                          ref="customerInformations"
                        />
                      </BContainer>
                    </BTab>

                    <BTab lazy>
                      <template #title>
                        <i :class="iconState('fa-history', currentTabIndex === 1)" /> Interactions
                      </template>

                      <BContainer
                        class="h-100 p-0"
                        fluid
                      >
                        <CustomerInteractions
                          ref="customerInteractions"
                          :customer="customerProfile"
                        />
                      </BContainer>
                    </BTab>

                    <BTab lazy>
                      <template #title>
                        <i :class="iconState('fa-file-zipper', currentTabIndex === 4)" /> Documents
                      </template>

                      <BContainer
                        class="h-100 p-0"
                        fluid
                      >
                        <CustomerDocuments
                          ref="customerDocuments"
                          :customer="customerProfile"
                        />
                      </BContainer>
                    </BTab>
                  </BTabs>
                </BCardText>
              </BCard>
            </BOverlay>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <BCard class="border">
              <BCardText>
                <div class="d-flex gap-4">
                  <BAvatar
                    v-if="officer.photo_url"
                    :src="computedProfilePath(officer.photo_url)"
                    variant="primary"
                    size="36px"
                  />
                  <BAvatar
                    v-else
                    variant="primary"
                    size="36px"
                    :text="String(officer?.first_name).charAt(0) + String(officer?.last_name).charAt(0)"
                  />
                  <div class="d-flex flex-column justify-content-center">
                    <div
                      class="font-weight-bolder"
                      style="font-size: 0.8rem;"
                    >
                      {{ officer?.first_name }} {{ officer?.last_name }}
                    </div>
                    <div
                      class="mt-1 text-dark"
                      style="font-size: 0.7rem;"
                    >
                      Creator
                    </div>
                  </div>
                </div>
              </BCardText>
            </BCard>
          </BCol>

          <BCol
            v-if="areaManager?.id"
            cols="12"
            md="4"
          >
            <BCard class="border">
              <BCardText>
                <div class="d-flex gap-4">
                  <BAvatar
                    v-if="areaManager.photo_url"
                    :src="computedProfilePath(areaManager.photo_url)"
                    variant="primary"
                    size="36px"
                  />
                  <BAvatar
                    v-else
                    variant="primary"
                    size="36px"
                    :text="String(areaManager?.first_name).charAt(0) + String(areaManager?.last_name).charAt(0)"
                  />
                  <div class="d-flex flex-column justify-content-center">
                    <div
                      class="font-weight-bolder"
                      style="font-size: 0.8rem;"
                    >
                      {{ areaManager?.first_name }} {{ areaManager?.last_name }}
                    </div>
                    <div
                      class="mt-1 text-dark"
                      style="font-size: 0.7rem;"
                    >
                      Verifier
                    </div>
                  </div>
                </div>
              </BCardText>
            </BCard>
          </BCol>

        </BRow>
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

import CustomerProfilePictures from '@/views/audit/customer-management/ProfilePictures.vue'
import CustomerInformations from '@/views/audit/customer-management/Informations.vue'
import CustomerInteractions from '@/views/audit/customer-management/interactions/Base.vue'
import CustomerDocuments from '@/views/audit/customer-management/documents/Base.vue'
import CustomerSuggestions from '@/views/audit/customer-management/Suggestions.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

export default {
  name: 'VAuditCustomerManagement',

  components: {
    CustomerProfilePictures,
    CustomerInteractions,
    CustomerInformations,
    CustomerDocuments,
    CustomerSuggestions
  },

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: ['auth', 'audit'],

  metaInfo: () => ({
    title: 'Customer Management'
  }),

  data () {
    return {
      state: {
        busy: false
      },
      currentTabIndex: 0,
      tasksCurrentTabIndex: 0,
      areaManager: {
        id: '',
        first_name: '',
        last_name: '',
        photo_url: ''
      },
      officer: {
        id: '',
        first_name: '',
        last_name: '',
        photo_url: ''
      },
      customerProfile: {
        id: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix_name: '',
        mobile_number: '',
        birth_date: '',
        gender: '',
        address: '',
        region_id: '',
        province_id: '',
        municipality_id: '',
        barangay_id: '',
        cluster_id: '',
        status: 'New',
        photos: [],
        farms: [],
        crops: [],
        is_blo: 0,
        is_aljay: 0,
        active: 1
      },
      formCustomerProfilePicture: {
        file: ''
      },
      customerAttachments: [],
      customerInteractions: [],
      customerTasks: []
    }
  },

  computed: mapGetters({
    showCustomerSuggestion: 'customer-management/showCustomerSuggestionState',
    currentUser: 'auth/user'
  }),

  watch: {
    '$route.params.customer' () {
      this.getCustomerProfile(true, false)
      this.currentTabIndex = 0
    }
  },

  mounted () {
    if (this.currentUser) {
      this.getCustomerProfile()

      this.$nextTick(() => {
        this.attachArrowScroller('.nav-customer-tabs')
      })
    }
  },

  destroyed () {
    this.detachArrowScroller('.nav-customer-tabs')
  },

  methods: {
    computedProfilePath (photoUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/${photoUrl}`
    },

    showOrHideCustomerSuggestions () {
      this.showCustomerSuggestions(!this.showCustomerSuggestion)

      this.$nextTick(() => {
        if (this.showCustomerSuggestion) {
          this.$refs.customerSuggestions.tableProvider()
        }
      })
    },

    setCustomerProfile (customer) {
      this.customerProfile = Object.assign(this.customerProfile, {
        id: customer.id,
        cluster_id: '',
        region_id: customer.region_id,
        province_id: customer.province_id,
        municipality_id: customer.municipality_id,
        barangay_id: customer.barangay_id,
        first_name: customer.first_name,
        middle_name: customer.middle_name,
        last_name: customer.last_name,
        suffix_name: customer.suffix_name,
        email: customer.email,
        mobile_number: customer.mobile_number,
        birth_date: customer.birth_date,
        gender: customer.gender,
        address: customer.address,
        status: customer.status,
        documents: customer?.documents || [],
        farms: customer?.farms || [],
        crops: customer?.crops || [],
        photos: customer?.photos || [],
        is_blo: customer.is_blo || 0,
        is_aljay: customer.is_aljay || 0,
        active: customer.active
      })
    },

    async getCustomerProfile (useLoader = true, useTableProvider = true) {
      this.state.busy = useLoader && true

      this.$refs.customerInformations.showInformation(this.$route.params.customer).then(
        async customer => {
          if (!customer) {
            return this.swalInvalid(
              '<h6>Your customer profile seems to be incorrect or incomplete, please check and try again.</h6>',
              'Customer Not Found'
            ).then(
              () => {
                this.$router.push({ name: 'audit.customers' })
              }
            )
          }

          this.areaManager = Object.assign(this.areaManager, {
            id: customer.verifier?.id,
            first_name: customer.verifier?.first_name,
            last_name: customer.verifier?.last_name,
            photo_url: customer.verifier?.photo_url
          })

          this.officer = Object.assign(this.officer, {
            id: customer.creator?.id,
            first_name: customer.creator?.first_name,
            last_name: customer.creator?.last_name,
            photo_url: customer.creator?.photo_url
          })

          this.$refs.customerInformations.viewInformation(customer)
          this.setCustomerProfile(customer)
        }
      ).finally(() => {
        if (useTableProvider && (this.showCustomerSuggestion || this.isMobile())) {
          this.$refs.customerSuggestions.tableProvider()
        }

        this.state.busy = false
      })
    },

    ...mapActions({
      showCustomerSuggestions: 'customer-management/showCustomerSuggestionAction'
    })
  }
}
</script>
